
import React, { Component } from 'react'
import '../Buttons/UploadImageButton/UploadImageButton.css'

export default class FileUploadButton extends Component {


    render() {
        const {onChange} = this.props;

        return (
            <div class="file-field upload-btn-wrapper">
                <div class="btn" style={{ marginBottom: 0, padding: "0px 20px" }}>
                    <p style={{ fontSize: "10px" }}>Upload</p>
                    <input type="file" multiple
                        onChange={(e) => onChange(e)}
                    />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FileUploadButton/FileUploadButton.js